import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import config from '../../config/channels';
import { operatorName } from '../../config/operator';
import { useLocalStorage } from '../../hooks/localstorage';
import { APIErrorCode } from '../../services/api';
import { getDeliveryVenues } from '../../services/api/delivery-venue';
import { getMenu } from '../../services/api/site';
import useOperatorContext from '../operator/useOperatorContext';
import { DeliveryVenueContext, DeliveryVenueContextData, TDeliveryVenue } from './delivery-venue-context';
import { MenuData, TMenu, TSite } from '../site/site-context';
import { iLog } from "../../index";

const DeliveryVenueContextProvider = ({ children }: { children: JSX.Element }) => {
    const [site, setSite] = useState<TSite | null>(null);
    const [menu, setMenu] = useState<TMenu | null>(null);
    const [flow, setFlow] = useState('noflow');

    const [deliveryVenues, setDeliveryVenues] = useState<TDeliveryVenue[] | null>(null);
    const [loading, setLoading] = useState(false);

    const operatorContext = useOperatorContext();

    const navigate = useNavigate();

    const fetchDeliveryVenue = (
        id: string,
        flow: string = '-',
        handle: string = operatorName,
    ) => {
        setLoading(true);

        if (operatorContext.operator) {
            flow = operatorContext.operator.flow ?? '';
        }

        getMenu(handle, id, 'venues', flow, undefined, undefined)
            .then((data: MenuData) => {
                // TODO IF  SITE IS NOT FOUND HERE, THEN REDIRECT TO 404?? Maybe API needs to 404?

                iLog('Site fetched:', [id, data]);
                setSite(data.site);
                setMenu(data.menu);
                setFlow(data.flow ?? 'noflow');
            })
            .catch((error) => {
                iLog('Issue fetching menu', [error.code]);
                navigate('/404');
            })
            .finally(() => {
                setLoading(false)
            });
    };

    const fetchDeliveryVenues = (handle: string, flow: string) => {
        setLoading(true);

        getDeliveryVenues(handle, flow)
            .then((data) => {
                iLog('fetchDeliveryVenues', data);
                setDeliveryVenues(data);
                setFlow(data.flow ?? 'noflow');
            })
            .catch((error) => {
                console.error('issue fetching delivery venues');
                navigate('/500');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    let deliveryVenueContextValue: DeliveryVenueContextData = {
        site,
        menu,

        fetchDeliveryVenue,

        deliveryVenues,
        fetchDeliveryVenues,

        loading,
        setLoading,

        flow,
        setFlow,
    };
    return <DeliveryVenueContext.Provider value={deliveryVenueContextValue}>{children}</DeliveryVenueContext.Provider>;
};

export default DeliveryVenueContextProvider;
